<template>
  <Modal id="feedback-detail" modifier="testimonial" #default="{ close, options }">
    <div class="close" @click="close">
      <SvgIcon name="close" />
    </div>

    <TestimonialCard v-if="options" modifier="full" :data="options" />
  </Modal>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

import { withUi } from '@/components/ui'
import Modal from '@/components/modals/Modal'
import TestimonialCard from '@/components/testimonials/Card'

export default {
  name: 'ModalFeedbackDetail',
  components: { Modal, TestimonialCard },
  mixins: [withUi],
  data() {
    return {}
  },
  methods: {
    ...mapMutations(['closeModal']),
  },
}
</script>

<style lang="scss">
#modal-feedback-detail {
  .close {
    position: absolute;
    z-index: 3;
    top: 20px;
    right: 10px;
    color: $dark;
    font-size: 0;
    padding: 10px;
    cursor: pointer;
    transition: color 0.25s $ease;
    .svg-icon {
      font-size: 14px;
    }
    &:hover {
      color: $primary;
    }
  }
  h2 {
    font-size: 14px;
    margin-bottom: 32px;
    text-align: left;
  }
}
</style>
